export default __webpack_public_path__ + "static/loupe-navigation-redesign-project-context-b5e621072a4fe1279033ba5d66bb0fd6.png";